<template>
	<div id="Case" class="mainPage">
		<div id="banner">
			<div class="container">
				<div class="text">
					<h2>智见优选客户成功案例</h2>
				</div>
			</div>
			<img src="../assets/img/cb.jpg"/>
		</div>
		<div class="main">
			<div class="mainBox">
				<div class="title">
					<h2>成功案例</h2>
					<p>
						<span>CASES</span>
					</p>
				</div>
				<div class="container case">
					<div class="caseBox">
						<div>
							<div class="left">
								<img src="../assets/img/pt10.png"/>
								<b>客户简介</b>
								<p>京东数字科技集团孵化于京东集团，是一家全球领先的数字科技公司，致力于为金融机构、商户与企业、政府及其他客户提供全方位数字化解决方案。公司以大数据、人工智能、云计算、 区块链等新一代信息技术为基础，为客户提供“科技（Technology）+产业（Industry）+生态（Ecosystem）”的全方位服务，打造产业数字化“联结（TIE）”模式。</p>
							</div>
						</div>
						<div>
							<div class="right">
								<h4>文档数据自动化处理，助力企业降本增效</h4>
								<b>核心诉求</b>
								<p>金融行业是合规要求非常严格的场景，在各个工作环节中盖章的PDF文件必不可少，但是PDF文件不可编辑，内容及数据提取难。大量的非结构化PDF文件需通过进行人工提取、质检、入库等，整个过程数据处理工作量大且繁琐，工作效率低、准确率低，从而导致数据分析困难，难以最大化实现数据效用的问题。</p>
								<b>解决方案</b>
								<p>深能智见的文档数据自动化流水线，通过文字识别能力可迅速完成PDF文件中的信息识别；再通过自然语言处理能力从复杂的语言描述中提取出关键的数据信息进行结构化输出；利用自动质检工具对数据进行质检。实现了京东数科每月3000份PDF文档迅速结构化，与传统人工处理相比，整体处理时间缩短90%以上。</p>
								<img src="../assets/img/c1.png"/>
							</div>
						</div>
					</div>
					<!-- <div class="caseBox">
						<div >
							<div class="left">
								<img src="../assets/img/pt14.png"/>
								<b>客户简介</b>
								<p>万怡医学是一家专业学术会议组织机构（PCO）及品牌会议策划机构（BC）。从成立至今，万怡会展已成功承办世界胃肠病大会、世界心理治疗大会、国际粒子放射治疗大会、丝绸之路经济论坛等上百场国际前沿学术会议，致力将“万怡制造”的学术会议打造成严密、精致、高端、领先的会议品牌。</p>
							</div>
						</div>
						<div>
							<div class="right">
								<h4>智能视频处理流水线，让线上会展更简单</h4>
								<b>核心诉求</b>
								<p>疫情影响，万怡医学加速了商业模式的在线化、网络化、智能化发展。将会展由线下转为线上，建立了专业线上医学知识交流平台。但是线上视频资源处理面临着跟不上会展交流节奏而导致资源脱节等问题。因此，如何保证视频资源快速标准化，便捷拆分视频内容并关联知识点，从而提高生产能力、为用户提供更加高效的服务，成为了平台首要解决的难题。</p>
								<b>解决方案</b>
								<p>万怡医学通过深能智见的视频数据自动化流水线，实现了医学会展视频中的知识点拆条，形成单一的知识点视频。同时根据视频内容智能生成知识图谱，建立结构化知识模型。<br>高效推进了时效性视频资源产出，也大大节省了人力成本、视频处理资源成本。</p>
								<img src="../assets/img/c2.png"/>
							</div>
						</div>
					</div> -->
					<div class="caseBox">
						<div>
							<div class="left">
								<img src="../assets/img/pt02.png"/>
								<b>客户简介</b>
								<p>百联集团是上海市最大的零售企业，注册资本10亿元，总资产800亿元。主要业务涵盖主题百货、购物中心、奥特莱斯，大型卖场、标准超市、便利店、专业专卖等零售业态，经营有色金属、汽车、化轻、机电、木材、电子信息等领域。</p>
							</div>
						</div>
						<div>
							<div class="right">
								<h4>AI赋能数据治理，驱动营销决策智能化</h4>
								<b>核心诉求</b>
								<p>百联集团作为上海最大的零售企业，业务面广，合作供应商多，涉及到的品牌和商品更是数不胜数。但是品牌和商品等各类数据数据来源广，格式丰富，很难统一管理；同时企业现有IT系统陈旧，数据零散，造成数据孤岛现象严重。如何高效且高准确率的对海量数据进行梳理，实现商务智能分析成为亟待解决的问题。</p>
								<b>解决方案</b>
								<p>深能智见帮助百联集团建立并规范了公司的数据治理整套体系，涵盖了从数据产生到数据归档的整个数据生命周期的数据治理能力。提供了数据标准和指标、满足质量和分析要求的数据、以及自动化的数据处理流水线。<br>全面提升数据质量，实现了数据中心的统一监管，灵活分析品牌和商品数据的各项指标，最大化挖掘数据价值。</p>
								<img src="../assets/img/c3.png"/>
							</div>
						</div>
					</div>
				</div>
			</div>
	
		</div>
	</div>
</template>

<script>
export default{
	name:'Case',
	data() {
		return {
			serveBg:{
				backgroundImage:'url(' + require('../assets/img/serveBg.jpg') + ')'
			},
			gdbjBg:{
				backgroundImage:'url(' + require('../assets/img/abbg.jpg') + ')'
			},
			ptLogo:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20']
		}
	}
}
</script>

<style lang="scss">
#Case{
	.mainBox{
		.title{
			margin-bottom: 50px;
		}
		.case{
			.caseBox{
				margin-bottom: 70px;
				display: flex;
				>div{
					&:nth-child(1){
						flex:0 0 300px;
						padding: 20px;
						border:1px solid #ddd;
					}
					&:nth-child(2){
						flex:1;
					}
				}
			}
			.left{
				img{
					width: 80%;
					margin-bottom: 40px;
				}
				b{
					display: block;
					margin-bottom: 15px;
				}
				p{
					line-height: 30px;
					margin:0;
				}
			}
			.right{
				padding-left: 40px;
				h4{
					font-weight: bold;
					margin-top: 0;
					margin-bottom: 30px;
					font-size:22px;
				}
				b{
					margin: 20px 0;
					display: block;
					font-size: 14px;
				}
				p{
					line-height: 25px;
				}
				img{
					width: 100%;
					margin-top:20px;
				}
			}
			
		}
	}
}
</style>